module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="action-properties"></div>\n<div class="size-and-position-properties"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/productWidget/ProductWidgetPropertiesView.tpl
// module id = 2053
// module chunks = 0